// função que efetua validação do CNPJ (Suporte CNPJ 2.0 Alfanumérico)
function validate(cnpj) {
  if (!cnpj || String(cnpj).length === 0) return true;
  
  // Converte para maiúsculas e remove caracteres não alfanuméricos
  cnpj = String(cnpj).toUpperCase().replace(/[^A-Z0-9]/g, '');
  
  if (cnpj.length !== 14) return false;

  // Os dois últimos dígitos (DVs) DEVEM ser numéricos
  if (!/^[0-9]{2}$/.test(cnpj.substring(12))) return false;

  // Função interna para calcular o dígito verificador usando Módulo 11 e conversão ASCII
  const calculateDV = (base) => {
    const weights = base.length === 12 
      ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] 
      : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    
    let sum = 0;
    for (let i = 0; i < base.length; i++) {
      let char = base[i];
      // Conversão alfanumérica: Valor ASCII - 48
      // '0' (48) -> 0
      // 'A' (65) -> 17
      let val = char.charCodeAt(0) - 48;
      sum += val * weights[i];
    }
    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
  };

  const dv1 = calculateDV(cnpj.substring(0, 12));
  const dv2 = calculateDV(cnpj.substring(0, 12) + dv1);

  return cnpj.endsWith("" + dv1 + dv2);
}

export default validate;



// WEBPACK FOOTER //
// ./src/shared/cnpj.js